export interface IEstimatedUtilityDetail {
    currentUtilityRate: number;
    estimatedAnnualUsage: number;
}

export class EstimatedUtilityDetail implements IEstimatedUtilityDetail {
    currentUtilityRate: number;
    estimatedAnnualUsage: number;
}
